module.exports = __webpack_public_path__ + "08_hair_silver.eb57eacd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/08_hair_silver.png
// module id = EETk
// module chunks = 0